module.exports = __webpack_public_path__ + "842bf5477b35f2a5a3ff267dcf585031.pdf";